import { createContext, useContext } from 'react';
import { SocialMediaResponse } from './services/socialMediaCommonApi';
import { ISocialMediaContext } from './types';

export interface ISocailMediaFormData {
  topic: string;
  subTopic: string;
  description: string;
  tone: string;
  language: string;
  drafts: number;
  imageType: string;
}

export interface PlatformConnection {
  isConnected: boolean;
  username?: string;
  lastConnected?: Date;
  token?: string;
}

export interface Connections {
  linkedin: PlatformConnection;
  x: PlatformConnection;
}

export interface SocialMediaContextType {
  // Content and UI state
  socialMediaContent: ISocialMediaContext[] | null;
  isEditing: boolean;
  isSettingSocialMedia: boolean;
  formData?: ISocailMediaFormData;
  
  // Connection state
  connections: Connections;
  
  // Content management methods
  setIsEditing: (e: boolean) => void;
  handleUpdateSocialMediaContent: (data: SocialMediaResponse[]) => void;
  updateFormData: (e: ISocailMediaFormData) => void;
  updateSocialMediaContent: (data: ISocialMediaContext[]) => void;
  
  // Connection management methods
  connectPlatform: (platform: 'linkedin' | 'x', connectionData: PlatformConnection) => void;
  disconnectPlatform: (platform: 'linkedin' | 'x') => void;
  isPlatformConnected: (platform: 'linkedin' | 'x') => boolean;
  getPlatformUsername: (platform: 'linkedin' | 'x') => string | undefined;
}

const defaultConnections: Connections = {
  linkedin: { isConnected: false },
  x: { isConnected: false }
};

// Create context with initial values
export const SocialMediaContext = createContext<SocialMediaContextType>({
  socialMediaContent: null,
  isEditing: false,
  isSettingSocialMedia: false,
  connections: defaultConnections,
  
  setIsEditing: () => {},
  handleUpdateSocialMediaContent: () => {},
  updateFormData: () => {},
  updateSocialMediaContent: () => {},
  connectPlatform: () => {},
  disconnectPlatform: () => {},
  isPlatformConnected: () => false,
  getPlatformUsername: () => undefined,
});

export const useSocialMediaContext = () => useContext(SocialMediaContext);